import React, { useContext, useEffect, useRef, useState } from "react";
import "vidstack/styles/defaults.css";
import "vidstack/styles/community-skin/video.css";
import { TabView, TabPanel } from "primereact/tabview";
import { Link, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { Toast } from "primereact/toast";
import { FreeMode, Navigation, Thumbs, Zoom } from "swiper/modules";
import "swiper/css/zoom";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
// context
import { UserData } from "../contexts/UserInfoContext";
import { CartDataContext } from "../contexts/CartContext";
// import { compareDataContext } from "../contexts/CompareContext";
import ScrollTop from "../components/shared/ScrollTop";

// components
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ProductSidebarWrapper from "../components/Product/ProductPage/ProductSidebarWrapper";
import Footer from "../components/Footer/Footer";

// icons
import { FiList } from "react-icons/fi";
import { BiMessageSquareDetail } from "react-icons/bi";
import { TbTruckDelivery } from "react-icons/tb";
import { MdOutlineSecurity } from "react-icons/md";

// API
import { deleteData, getData, postData } from "../services/API";
// import ScrollTop from "../components/shared/ScrollTop";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  dropDownObject,
  priceObject,
  tagsObject,
  toFarsiNumber,
} from "../helper/helper";
// import Compare from "../components/Compare/Compare";
import Loading from "../components/shared/Loading";
import ProductImage from "../components/Product/ProductPage/ProductImage";
import { favouriteListContext } from "../contexts/FavouriteContext";
import { getItemStorage } from "../Localstorage/useLocalStorage";
import { Rating } from "primereact/rating";
import SendComment from "../components/Product/ProductPage/SendComment";
import ProductComment from "../components/Product/ProductPage/ProductComment";
import Compare from "../components/Compare/Compare";
import { compareDataContext } from "../contexts/CompareContext";
import { Dropdown } from "primereact/dropdown";
import { TreeSelect } from "primereact/treeselect";
import CircleLoading from "../components/shared/CircleLoading";
import Input from "../components/shared/Form/Input";

const ProductPage = () => {
  const { user } = useContext(UserData);
  const { cart, setCart, updateCart } = useContext(CartDataContext);
  const { favouriteList, setFavouriteList } = useContext(favouriteListContext);
  const { compareData, setCompareData, openCompare, setOpenCompare } =
    useContext(compareDataContext);

  const [cartButtonLoading, setCartButtonLoading] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [product, setProduct] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [addedFav, setAddedFav] = useState(false);
  const [features, setFeatures] = useState([]);
  const [rate, setRate] = useState(null);
  const [rateSended, setRateSended] = useState(false);
  const [commentLoading, setCommentLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openPic, setOpenPic] = useState(false);
  const [prices, setPrices] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState({});
  const [courses, setCourses] = useState([]);
  const [pages, setPages] = useState(0);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const maxPage = Math.ceil(courses.length / 6);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sendRate, setSendRate] = useState(false);
  const [rateLoading, setRateLoading] = useState(false);
  const [isRateSubmitted, setIsRateSubmitted] = useState(null);
  const [errMsg, setErrMsg] = useState({});
  const [allCourses, setAllCourses] = useState([]);
  const [search, setSearch] = useState("");

  const token = getItemStorage("token");

  const param = useParams("slug");

  const toastErr = useRef(null);
  const toastLogin = useRef(null);
  // time
  const getProducts = () => {
    getData(`/shop/product/show/${param.slug}`, {}, true)
      .then((res) => {
        setProduct(res.data);
        setLoading(false);
        const productFeatures =
          res.data.features?.length > 0 ? res.data.features?.split(",") : [];
        setFeatures(productFeatures);

        setCartButtonLoading(false);

        res.data.lessons.forEach((item) => {
          item.lesson && setAllCourses((prev) => [...prev, item]);
          item.lesson && setCourses((prev) => [...prev, item]);
        });

        setPrices(priceObject(res.data.prices));
        setSelectedPrice(priceObject(res.data.prices)[0]);

        if (res.data.user_rate) {
          setIsRateSubmitted(res.data.user_rate);
          setRate(res.data.user_rate);
        }

        // get comments
        postData(
          `/shop/comment/get-product-comments`,
          {
            product_id: res.data.id,
            page: 1,
          },
          true
        )
          .then((res) => {
            setComments(res.data.comments);
            setCommentLoading(false);
          })
          .catch((res) => {
            toastErr.current.show({
              severity: "error",
              summary: "خطا هنگام دریافت دیدگاه کاربران",
              detail: "لطفا دوباره صفحه را بارگذاری کنید",
              life: 3500,
            });
          });
      })
      .catch((res) => {
        // toastErr.current.show({
        //   severity: "error",
        //   summary: "خطا هنگام دریافت اطلاعات از سرور",
        //   detail: "لطفا دوباره صفحه را بارگذاری کنید",
        //   life: 3500,
        // });
      });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    getData("/acd/category/get-sorted", {}, true)
      .then((res) => {
        setCategories(tagsObject(res.data));
        setCategoriesLoading(false);
      })
      .catch((res) => {
        toastErr.current.show({
          severity: "error",
          summary: "خطا هنگام دریافت اطلاعات از سرور",
          detail: "لطفا دوباره صفحه را بارگذاری کنید",
          life: 3500,
        });
      });

    getProducts();
  }, []);

  // add product to cart
  const addToCart = () => {
    setErrMsg({});
    setCartButtonLoading(true);

    if (product.title) {
      postData(
        "/shop/cart/add",

        {
          categories: selectedCategories && Object.keys(selectedCategories),
          product_id: product.id,
          price_id: selectedPrice.id,
          quantity: 1,
        },
        true
      )
        .then((res) => {
          // update cart
          updateCart();

          // update button
          getProducts();
        })
        .catch((err) => {
          setCartButtonLoading(false);
          setErrMsg(err.response.data);

          if (err.response.data.message === "Unauthenticated.") {
            toastLogin.current.show({
              severity: "error",
              summary: "لطفا وارد شوید",
              detail: "برای افزودن محصول به سبد خرید وارد شوید",
              life: 3500,
            });
          } else {
            toastErr.current.show({
              severity: "error",
              summary: "خطا هنگام افزودن به سبد خرید",
              detail: err.response.data.message,
              life: 4000,
            });
          }
        });
    }
  };

  // remove product from cart
  const removeFromCart = () => {
    setCartButtonLoading(true);

    cart.items?.forEach((c) => {
      if (c.info.id === product.id) {
        postData(`/shop/cart/delete`, { cart_id: c.id })
          .then((res) => {
            // update cart
            updateCart();

            // update button
            getProducts();
          })
          .catch((err) => {
            setCartButtonLoading(false);

            toastErr.current.show({
              severity: "error",
              summary: "خطا هنگام حذف از سبد خرید",
              detail: "لطفا دوباره تلاش کنید کنید",
              life: 3500,
            });
          });
      }
    });
  };

  const increaseQuantity = () => {
    if (quantity < product.qty) {
      setQuantity((prev) => prev + 1);
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  // add or delete from compare list
  const addToCompare = () => {
    // open compare tab bottom of page
    setOpenCompare(true);

    // check if product in compare list
    const compare = compareData.filter((c) => c.id === product.id);

    // if was in compare list delete it otherwise add it
    if (compare.length > 0) {
      const newData = compareData.filter((c) => c.id !== product.id);

      setCompareData(newData);
    } else {
      setCompareData((prev) => [...prev, product]);
    }
  };
  // add or remove from favourite list

  const rateOnChangeHandler = (e) => {
    setRate(e.value);
    setSendRate(true);
  };

  const rateSendHandler = () => {
    setRateLoading(true);

    if (!rateSended) {
      postData("/shop/product/rate", {
        number: rate,
        product_id: product.id,
      })
        .then((res) => {
          setSendRate(false);
          setRateSended(true);
          toastSucc.current.show({
            severity: "success",
            summary: "با موفقیت انجام شد",
            detail: "امتیاز شما با موفقیت ثبت شد",
            life: 3500,
          });
        })
        .catch((err) => {
          toastErr.current.show({
            severity: "error",
            summary: "خطا هنگام ثبت امتیاز",
            detail: err.response.data.message,
            life: 3500,
          });
        });
    }
  };

  const onNextPage = () => {
    setPages((pages + 1) % maxPage);
  };

  const onPrevPage = () => {
    pages !== 0 && setPages((pages - 1) % maxPage);
  };

  const searchOnChangeHandler = (e) => {
    setSearch(e.target.value);
    // console.log(e.target.value);
    const filteredCourses = allCourses.filter(
      (course) => course.lesson && course.lesson.name.includes(e.target.value)
    );

    setCourses(filteredCourses);
  };

  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <Compare />
      <Header />
      <MobileNavbar />
      <MobileHeader />
      <ScrollTop />

      {/* toasts */}
      <Toast ref={toastErr} />
      <Toast className="cart-error" ref={toastLogin} />

      {/* open pic */}
      {!loading && (
        <>
          <div
            onClick={() => setOpenPic(false)}
            className={`fixed bg-black ${
              openPic ? "opacity-100 visible" : "opacity-0 invisible"
            } transition-all duration-300 bg-opacity-70 w-full h-full top-0 right-0 z-50`}
          ></div>

          <div
            className={`${
              openPic ? "opacity-100 visible" : "opacity-0 invisible"
            } transition-all duration-300 fixed flex justify-center items-center top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 px-3 z-50`}
          >
            <div className="sm:w-96 lg:w-[600px] w-full h-auto">
              <Swiper
                navigation={true}
                modules={[Navigation]}
                className="mySwiper"
              >
                {product.image?.map((img) => (
                  <SwiperSlide>
                    <ProductImage
                      key={img.id}
                      className="!bg-transparent"
                      img={img}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </>
      )}

      <div className="w-full xl:max-w-[1300px] mt-5 flex flex-col gap-7 px-3 2xl:px-0">
        {/* product details */}
        <div className="w-full bg-[#222] flex flex-col xl:flex-row gap-7 rounded-xl h-auto lg:p-7 p-5 overflow-hidden shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
          {product.title ? (
            <div className="xl:w-96 min-h-[480px] w-full flex justify-center items-center relative border border-gray-800 rounded-xl p-3">
              {/* product option */}
              {product?.title && (
                <>
                  <div className="w-11 absolute h-auto py-4 flex flex-col items-center justify-center gap-6 z-30 rounded-full bg-[#222] bg-opacity-80 right-6 top-6">
                    <button
                      onClick={() => setOpenPic(true)}
                      className="outline-none border-none group relative"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 stroke-gray-400 hover:stroke-yellow-700 transition-all duration-300"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                        />
                      </svg>

                      <div className="absolute opacity-0 invisible scale-0 group-hover:opacity-100 group-hover:visible group-hover:scale-100 transition-all duration-300 block w-36 py-2 text-[15px] top-2/4 right-12 -translate-y-2/4 bg-[#222] text-gray-200 border border-gray-800 shadow-lg rounded-full">
                        بزرگ نمایی تصویر
                      </div>
                    </button>

                    <button className="outline-none border-none group relative">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="w-6 h-6 fill-gray-400 hover:fill-yellow-700 transition-all duration-300"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z"
                          clip-rule="evenodd"
                        />
                      </svg>

                      <div className="absolute opacity-0 invisible scale-0 group-hover:opacity-100 group-hover:visible group-hover:scale-100 transition-all duration-300 block w-40 py-2 text-[15px] top-2/4 right-12 -translate-y-2/4 bg-[#222] text-gray-200 border border-gray-800 shadow-lg rounded-full">
                        اشتراک گذاری محصول
                      </div>
                    </button>
                  </div>
                </>
              )}

              <div className="w-full xl:min-w-96 h-full">
                <Swiper
                  spaceBetween={10}
                  zoom={true}
                  thumbs={{ swiper: thumbsSwiper }}
                  modules={[FreeMode, Thumbs, Zoom]}
                  className="mySwiper2"
                >
                  {product.image?.map((img) => (
                    <SwiperSlide>
                      <div className="swiper-zoom-container relative">
                        <ProductImage key={img.id} img={img} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <Swiper
                  onSwiper={setThumbsSwiper}
                  spaceBetween={10}
                  slidesPerView={4}
                  freeMode={true}
                  watchSlidesProgress={true}
                  modules={[FreeMode, Thumbs]}
                  className="mySwiper10 border-t py-4 border-gray-800"
                >
                  {product.image?.map((img) => (
                    <SwiperSlide>
                      <ProductImage key={img.id} img={img} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          ) : (
            <Skeleton className="rounded-xl block lg:!w-80 xl:!w-96 w-full h-[480px]" />
          )}

          <div className="w-full flex flex-col gap-4">
            {/* title */}

            <div className="w-full flex flex-col gap-3 border-b border-gray-800 pb-4">
              {product?.title ? (
                <>
                  <h1 className="text-gray-200 text-2xl font-black">
                    {product?.title}
                  </h1>
                  <div className="w-fit h-8 rounded-full text-sm flex items-center gap-2 px-3 bg-gradient-to-tl from-green-600 to-green-300 shadow-lg shadow-test text-white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-5 h-5 stroke-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
                      />
                    </svg>

                    <span>تضمین کیفیت خدمات</span>
                  </div>
                </>
              ) : (
                <>
                  <Skeleton className="rounded-xl block lg:w-80 h-12" />
                  <Skeleton className="rounded-xl block w-28 -mt-6 h-8" />
                </>
              )}
            </div>

            <div className="flex flex-col md:flex-row gap-5 w-full justify-between">
              {/* product info right side */}
              {product?.title ? (
                <div className="flex flex-col gap-5">
                  <div className="flex items-center text-gray-300 gap-2">
                    <div className="flex items-center justify-center w-8 h-8 rounded-lg shadow-lg border border-gray-800">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-5 h-5 fill-white"
                      >
                        <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                        <path
                          fillRule="evenodd"
                          d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>

                    {product?.updated_at && (
                      <span>{`بروزرسانی شده در تاریخ 
                        ${new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }).format(new Date(product?.updated_at))}`}</span>
                    )}
                  </div>

                  <div className="flex items-center text-gray-300 gap-2">
                    <div className="flex items-center justify-center w-8 h-8 rounded-lg shadow-lg border border-gray-800">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="w-5 h-5 fill-white"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>

                    <span>
                      {`${toFarsiNumber(
                        product.rate
                      )} امتیاز از ${toFarsiNumber(5)}`}
                    </span>
                  </div>

                  <div className="flex items text-gray-400 gap-2">
                    <div className="flex items-center justify-center w-8 h-8 rounded-lg shadow-lg border border-gray-800">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-5 h-5 fill-white"
                      >
                        <path d="M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z" />
                        <path
                          fillRule="evenodd"
                          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>

                    <div className="flex items-center gap-2">
                      {selectedPrice.off_price ? (
                        <div className="flex flex-col">
                          <div className="flex items-center gap-2">
                            <span className="text-xl text-gray-600 line-through">
                              {selectedPrice?.price &&
                                toFarsiNumber(Number(selectedPrice.price))}
                            </span>
                            <span className="text-2xl font-black text-gray-200">
                              {selectedPrice?.price &&
                                toFarsiNumber(Number(selectedPrice.off_price))}
                            </span>
                            <span className="text-gray-400">تومان</span>
                          </div>

                          <span className=" text-sm text-gray-500">
                            {toFarsiNumber(
                              Math.round(
                                100 -
                                  (Number(selectedPrice.off_price) * 100) /
                                    Number(selectedPrice.price)
                              )
                            )}
                            % تخفیف تا تاریخ{" "}
                            {new Intl.DateTimeFormat("fa-IR", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }).format(new Date(selectedPrice.off_expire))}
                          </span>
                        </div>
                      ) : (
                        <>
                          <span className="text-2xl font-black text-gray-200">
                            {selectedPrice?.price &&
                              toFarsiNumber(Number(selectedPrice.price))}
                          </span>
                          <span className="text-gray-400">تومان</span>
                        </>
                      )}
                    </div>
                  </div>

                  {product?.id === 9 && (
                    <Link
                      to={"/hr-land"}
                      target="_blank"
                      className="flex items-center text-blue-500 gap-2"
                    >
                      <div className="flex items-center justify-center w-8 h-8 rounded-lg shadow-lg border border-gray-800">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="size-5"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>

                      <span>اطلاعات بیشتر درباره دوره HR</span>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-4"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                        />
                      </svg>
                    </Link>
                  )}

                  {product?.buy || !user?.user ? (
                    <>
                      {product.limited === 1 && (
                        <div className="w-full col-span-2 md:col-span-1 flex flex-col gap-2">
                          <label className="text-gray-200">دسته بندی ها</label>
                          {categoriesLoading ? (
                            <Loading />
                          ) : (
                            <TreeSelect
                              options={categories}
                              value={selectedCategories}
                              disabled={product?.in_cart}
                              onChange={(e) => {
                                if (
                                  Object.keys(selectedCategories).length < 2
                                ) {
                                  setSelectedCategories(e.value);
                                }
                              }}
                              placeholder="دسته بندی مورد نظر را انتخاب کنید"
                              selectionMode="multiple"
                              metaKeySelection={false}
                              className={`w-full !max-w-[308px] rounded-xl bg-[#222] !border-gray-800 !font-[YekanBakh]`}
                            ></TreeSelect>
                          )}

                          {errMsg?.message && (
                            <span className="text-sm text-red-600">
                              {errMsg?.message ===
                              "لطفا دسته بندی ها را انتخاب کنید"
                                ? "لطفا دو دسته بندی انتخاب کنید"
                                : errMsg?.message}
                            </span>
                          )}
                        </div>
                      )}

                      <div className="w-full xl:w-60  mt-4 flex flex-col gap-2">
                        <label className="text-gray-200">مدت اشتراک</label>

                        <Dropdown
                          className="h-10 w-full filter-dropdown rounded-xl bg-[#222222] !text-gray-200 !border-gray-800 !text-sm flex items-center justify-center"
                          value={selectedPrice}
                          options={prices}
                          optionLabel="name"
                          onChange={(e) => setSelectedPrice(e.value)}
                          placeholder="مرتب سازی پیشفرض"
                        />
                      </div>

                      <div className="flex gap-5 items-center">
                        {product?.in_cart ? (
                          <button
                            onClick={removeFromCart}
                            className="flex shadow-lg w-48 h-10 shadow-test items-center gap-2 px-4 text-white rounded-xl bg-gradient-to-tl from-red-600 to-red-300"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              class="w-5 h-5 fill-white"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                clip-rule="evenodd"
                              />
                            </svg>

                            {cartButtonLoading ? (
                              <Loading
                                color={"before:bg-white"}
                                beforeWidth={"before:!w-3"}
                                beforeHeight={"before:!h-3"}
                                width={"!w-3"}
                                height={"!w-11"}
                              />
                            ) : (
                              <span>حذف از سبد خرید</span>
                            )}
                          </button>
                        ) : (
                          <button
                            onClick={addToCart}
                            className="flex shadow-lg w-52 h-10 border border-gray-800 items-center gap-2 px-4 text-white rounded-xl bg-gradient-to-tl from-yellow-900 to-yellow-500"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              class="w-5 h-5 fill-white"
                            >
                              <path d="M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" />
                            </svg>

                            {cartButtonLoading ? (
                              <Loading
                                color={"before:bg-white"}
                                beforeWidth={"before:!w-3"}
                                beforeHeight={"before:!h-3"}
                                width={"!w-3"}
                                height={"!w-11"}
                              />
                            ) : (
                              <span>افزودن به سبد خرید</span>
                            )}
                          </button>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="flex flex-col gap-5">
                      <div className="flex items-center text-gray-400 gap-2">
                        <div className="flex items-center justify-center w-8 h-8 rounded-lg shadow-lg border border-green-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-5 h-5 fill-green-500"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>

                        <span className="text-green-500 text-lg font-black">
                          پکیج را خریداری کرده اید
                        </span>
                      </div>

                      <div className="flex items-center text-gray-400 gap-2">
                        <div className="flex items-center justify-center w-8 h-8 rounded-lg shadow-lg border border-yellow-700">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-5 h-5 fill-yellow-700"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>

                        <span className="text-yellow-700">
                          {toFarsiNumber(product.days_left)} روز مانده تا پایان
                          دوره
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex flex-col gap-4">
                  <Skeleton className="w-48 h-7 rounded-xl block" />
                  <Skeleton className="w-36 h-7 rounded-xl -mt-6 block" />
                  <Skeleton className="w-52 h-7 rounded-xl -mt-6 block" />
                  <Skeleton className="w-60 h-7 rounded-xl -mt-6 block" />
                </div>
              )}

              {/* left side */}
              <div className="flex flex-col mt-3 lg:mt-0 gap-4">
                {product?.title ? (
                  <>
                    <div className="lg:w-80 w-full relative bg-gray-800 h-auto rounded-lg flex flex-col items-center">
                      <div className="min-w-52 text-gray-200 relative h-9 off-product-title">
                        <div className="absolute flex justify-center items-center gap-2 w-full h-full bg-[#222] left-2/4 -translate-x-2/4 rounded-b-2xl">
                          <span className="block w-3 h-[5px] bg-yellow-700 rounded-full shadow-md"></span>
                          <span>برخی از ویژگی ها</span>
                          <div className="off-product-title-left"></div>
                        </div>
                      </div>

                      {/* rules */}
                      <div className="flex flex-wrap gap-3 self-start p-4">
                        {features.length > 0 ? (
                          features.map((f, i) => (
                            <div
                              key={i}
                              className="text-gray-400 text-[14px] flex items-center gap-2"
                            >
                              <span className="block w-[5px] h-[5px] rounded-full bg-yellow-600 shadow-md border border-gray-800"></span>

                              <span>{f}</span>
                            </div>
                          ))
                        ) : (
                          <span className="text-gray-400">
                            ویژگی ای برای این محصول تعریف نشده !
                          </span>
                        )}
                      </div>
                    </div>

                    {product?.tests.length > 0 && (
                      <div className="lg:w-80 w-full relative bg-gray-800 h-auto rounded-lg flex flex-col items-center">
                        <div className="min-w-52 text-gray-200 relative h-9 off-product-title">
                          <div className="absolute flex justify-center items-center gap-2 w-full h-full bg-[#222] left-2/4 -translate-x-2/4 rounded-b-2xl">
                            <span className="block w-3 h-[5px] bg-yellow-700 rounded-full shadow-md"></span>
                            <span>تست های خود ارزیابی</span>
                            <div className="off-product-title-left"></div>
                          </div>
                        </div>

                        <div className="flex flex-wrap gap-3 self-start p-4">
                          {product.tests.length > 0 ? (
                            product.tests.map((f, i) => (
                              <div
                                key={i}
                                className="text-gray-400 text-[14px] flex items-center gap-2"
                              >
                                <span className="block w-[5px] h-[5px] rounded-full bg-yellow-600 shadow-md border border-gray-800"></span>

                                <span>
                                  {f.test === "neo"
                                    ? "تست نئو"
                                    : f.test === "mbti"
                                    ? "تست ام بی تی آی"
                                    : f.test === "holland"
                                    ? "تست هالند"
                                    : f.test === "disc"
                                    ? "تست دیسک"
                                    : " "}
                                </span>
                              </div>
                            ))
                          ) : (
                            <span className="text-gray-400">
                              ویژگی ای برای این محصول تعریف نشده !
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <Skeleton className="lg:w-80 w-full rounded-xl h-40 block" />
                    <Skeleton className="lg:w-80 w-full rounded-xl h-40 block" />
                  </>
                )}

                {/* fast delivery */}
                {/* <div className="grid grid-cols-2 gap-4">
                  {product?.title ? (
                    <>
                      <button className="w-full flex shadow-lg items-center gap-2 px-4 py-2 text-white rounded-xl bg-gradient-to-tl from-orange-700 to-orange-400">
                        <TbTruckDelivery className="text-white text-[22px]" />

                        <span>ارسال سریع</span>
                      </button>

                      <button className="w-full flex shadow-lg items-center gap-2 px-4 py-2 text-white rounded-xl bg-gradient-to-tl from-green-700 to-green-400">
                        <MdOutlineSecurity className="text-white text-[22px]" />

                        <span>پرداخت امن</span>
                      </button>
                    </>
                  ) : (
                    <>
                      <Skeleton className="w-full rounded-xl h-10 block" />
                      <Skeleton className="w-full rounded-xl h-10 block" />
                    </>
                  )}
                </div> */}
              </div>
            </div>

            {/* categories & tags */}
            <div className="w-full grid 2xl:grid-cols-2 grid-cols-1 mt-6 gap-5">
              {product?.title ? (
                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-2">
                    <div className="flex border border-gray-800 justify-center items-center w-8 h-8 rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="w-5 h-5 fill-white"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 0 1 1.5 10.875v-3.75Zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 0 1-1.875-1.875v-8.25ZM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 0 1 3 18.375v-2.25Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>

                    <h3 className="text-gray-200">دسته بندی ها :</h3>
                  </div>
                  <div className="flex items-center flex-wrap gap-2">
                    {product.title &&
                      product?.categories.map((tag) => (
                        <div className="block bg-yellow-800 bg-opacity-10 rounded-lg px-2 py-1 text-yellow-600 text-sm">
                          {tag.name}
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-4">
                  <Skeleton className="w-32 h-9 rounded-xl block" />
                  <Skeleton className="w-full h-9 rounded-xl -mt-6 block" />
                </div>
              )}

              {product?.title ? (
                <div className="flex flex-col gap-3"></div>
              ) : (
                <div className="flex flex-col gap-4">
                  <Skeleton className="w-32 h-9 rounded-xl block" />
                  <Skeleton className="w-full h-9 rounded-xl -mt-6 block" />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* product description & comments */}
        <div className="mb-10">
          <TabView className="tabview-header-icon">
            {/* course info */}
            <TabPanel
              header="توضیحات محصول"
              leftIcon={<FiList className="text-xl" />}
            >
              <div className="flex flex-col-reverse lg:flex-row gap-4">
                {/* product desc */}
                <div className="w-full flex flex-col mt-4 gap-4">
                  {product?.lessons?.length > 0 && (
                    <ProductSidebarWrapper
                      title={"دوره های موجود در این محصول"}
                      className="w-full"
                      line={true}
                      titleClassName="font-black text-gray-200"
                    >
                      <div className="max-w-96 mb-2">
                        <Input
                          element={"input"}
                          placeHolder={"دوره مورد نظر را جست و جو کنید"}
                          value={search}
                          onChange={searchOnChangeHandler}
                        />
                      </div>

                      {product?.lessons ? (
                        courses.length > 0 ? (
                          <div className="flex flex-col gap-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                              {courses.slice(pages * 6, 6 * (pages + 1)).map(
                                (lesson) =>
                                  lesson.lesson && (
                                    <Link
                                      target="_blank"
                                      to={`/courses/${lesson.lesson.slug}`}
                                      className="border border-gray-800 hover:border-gray-700 transition-all duration-300 flex gap-2 items-center p-2 rounded-xl h-20"
                                    >
                                      <img
                                        src={`https://api.myunibest.com/${lesson.lesson.image}`}
                                        className="h-full rounded-lg"
                                        alt=""
                                      />
                                      <div className="flex flex-col gap-3">
                                        <h3 className="text-gray-200 line-clamp-1 font-bold">
                                          {lesson.lesson.name}
                                        </h3>
                                        <p className="text-sm text-gray-400 line-clamp-1">
                                          {lesson.lesson.short_desc}
                                        </p>
                                      </div>
                                    </Link>
                                  )
                              )}
                            </div>

                            <div className="flex gap-3 items-center justify-center">
                              <button
                                onClick={onPrevPage}
                                className="size-10 bg-gray-800 rounded-xl flex items-center justify-center text-yellow-700"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="size-6"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                                  />
                                </svg>
                              </button>

                              <span className="text-gray-200">
                                {toFarsiNumber(pages + 1)}/
                                {toFarsiNumber(maxPage)}
                              </span>

                              <button
                                onClick={onNextPage}
                                className="size-10 bg-gray-800 rounded-xl flex items-center justify-center text-yellow-700"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="size-6"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        ) : (
                          <span className="text-gray-200">
                            دوره ای در این محصول وجود ندارد !
                          </span>
                        )
                      ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                          <Skeleton className="w-full h-20 block rounded-xl" />
                          <Skeleton className="w-full h-20 block rounded-xl" />
                          <Skeleton className="w-full h-20 block rounded-xl" />
                        </div>
                      )}
                    </ProductSidebarWrapper>
                  )}

                  <ProductSidebarWrapper
                    title={"توضیحات"}
                    className="w-full"
                    line={true}
                    titleClassName="font-black text-gray-200"
                    contentClassName={"!mt-0"}
                  >
                    {product.description ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: product.description,
                        }}
                        className="!text-gray-300 product-desc leading-7"
                      ></div>
                    ) : (
                      <div className="w-full h-fit">
                        <Skeleton count={2} className="w-full h-3 block" />
                        <Skeleton className="lg:w-80 w-full h-3 block" />
                        <Skeleton className="lg:w-[500px] w-full h-3 block" />
                        <Skeleton className="lg:w-full w-full h-3 block" />
                        <Skeleton className="lg:w-20 w-full h-3 block" />
                      </div>
                    )}
                  </ProductSidebarWrapper>
                </div>
              </div>
            </TabPanel>

            {/* comments */}
            <TabPanel
              header="دیدگاه کاربران"
              leftIcon={<BiMessageSquareDetail className="text-xl" />}
            >
              {/* comment section */}
              <div className="w-full h-auto flex mt-4 flex-col gap-10 p-5 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
                <div className="flex flex-col gap-6">
                  {/* comment title */}
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                      <h3 className="text-2xl font-black text-gray-200">
                        دیدگاه شما
                      </h3>
                    </div>
                  </div>

                  {token ? (
                    <div className="flex flex-col gap-5">
                      <div className="w-full md:max-h-14 flex flex-col-reverse md:flex-row gap-4 justify-between items-center p-4 bg-gray-800 rounded-xl">
                        {product.buy ? (
                          <span className="text-gray-200">
                            برای ثبت امتیاز ابتدا پکیج را خریداری کنید
                          </span>
                        ) : isRateSubmitted ? (
                          <span className="text-green-600">
                            شما قبلا امتیاز داده اید
                          </span>
                        ) : sendRate ? (
                          <div className="flex flex-col md:flex-row text-gray-200 items-center gap-4">
                            <span>مطمنید میخواهید امتیاز شما ثبت شود ؟</span>

                            <div className="flex items-center gap-4">
                              <button
                                onClick={rateSendHandler}
                                className="bg-gradient-to-tl from-green-600 to-green-300 text-sm p-2 text-white rounded-xl"
                              >
                                {rateLoading ? (
                                  <CircleLoading />
                                ) : (
                                  "بله ثبت امتیاز"
                                )}
                              </button>
                              <button
                                onClick={() => {
                                  setSendRate(false);
                                  setRate(null);
                                }}
                                className="text-red-600"
                              >
                                خیر
                              </button>
                            </div>
                          </div>
                        ) : rateSended ? (
                          <span className="text-green-500">
                            امتیاز شما ثبت شد
                          </span>
                        ) : (
                          <span className="text-gray-200">امتیاز شما</span>
                        )}
                        <Rating
                          value={rate}
                          readOnly={
                            rateSended || isRateSubmitted || product.buy
                              ? true
                              : false
                          }
                          cancel={false}
                          onChange={rateOnChangeHandler}
                        />
                      </div>

                      <SendComment data={product.id} />
                    </div>
                  ) : (
                    <span className="text-gray-200">
                      برای ثبت امتیاز و دیدگاه وارد حساب کاربری شوید !
                    </span>
                  )}
                </div>

                <div className="flex flex-col gap-6">
                  {/* comment title */}
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                      <h3 className="text-2xl font-black text-gray-200">
                        دیدگاه کاربران
                      </h3>
                    </div>

                    <span className="text-lg text-gray-400">
                      {!commentLoading && toFarsiNumber(comments.length)} دیدگاه
                    </span>
                  </div>

                  {/* comments */}
                  {commentLoading && loading ? (
                    <Loading />
                  ) : (
                    <div className="flex flex-col gap-4">
                      {comments.length > 0 ? (
                        comments.map((comment) => (
                          <ProductComment
                            product_id={product.id}
                            data={comment}
                          />
                        ))
                      ) : (
                        <span className="text-gray-200">
                          دیدگاهی برای این دوره وجود ندارد !
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProductPage;
